import { palette } from '../palette';

export const MuiInputBase = {
  styleOverrides: {
    root: {
      color: palette.black,
    },
    input: {
      backgroundColor: palette.grey.light,
      '&[type=number]': {
        MozAppearance: 'textfield',
      },
      '&::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '&::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
    },
  },
};
